const monoliths = ["/partners/sign_in", "/cso_multi_payday.pdf"];

export default monoliths;
